import { Component } from '@angular/core';

@Component({
  templateUrl: '../../../../../../assets/images/toastWarning.svg',
})
export class ToastWarningComponent { }
